<template>
  <HpLayout>
    <div class="japanese">
      <div class="mainsection fade_in">
        <div class="headerLinks"></div>
        <div class="tabs clearfix">
          <div class="tabsLeft">
            <ul>
              <li><a>ページ</a></li>
            </ul>
          </div>
          <div class="tabsRight">
            <ul>
              <li><a class="active">閲覧</a></li>
              <li><a>ソースを編集</a></li>
              <li><a>履歴表示</a></li>
            </ul>
          </div>
        </div>
        <div class="article">
          <h1>Adbc株式会社</h1>
          <p class="siteSub">出典：Adbc株式会社</p>
          <p class="roleNote">
            この項目では、Adbc株式会社について説明しています。
          </p>
          <table class="rightbox">
            <caption class="rightbox-title">
              Adbc株式会社
            </caption>
            <tbody>
              <tr>
                <td colspan="2" class="rightbox-image">
                  <img
                    alt="Adbc株式会社"
                    src="../../assets/hp/img/adbc-logo.jpg"
                    decoding="async"
                  />
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <div
                    style="
                      display: inline-block;
                      line-height: 1.2em;
                      padding: 0.1em 0;
                    "
                  >
                    種類
                  </div>
                </th>
                <td>株式会社</td>
              </tr>
              <tr>
                <th scope="row">
                  <div
                    style="
                      display: inline-block;
                      line-height: 1.2em;
                      padding: 0.1em 0;
                    "
                  >
                    市場情報
                  </div>
                </th>
                <td>非上場</td>
              </tr>
              <tr>
                <th scope="row">
                  <div
                    style="
                      display: inline-block;
                      line-height: 1.2em;
                      padding: 0.1em 0;
                    "
                  >
                    本社所在地
                  </div>
                </th>
                <td>
                  <img
                    alt="日本の旗"
                    src="../../assets/hp/img/Japan.svg.png"
                    decoding="async"
                    width="25"
                    height="17"
                    class="thumbborder"
                    data-file-width="900"
                    data-file-height="600"
                  />日本<br />
                  <span style="color: red"><b>〒</b></span
                  >176-0001<br />
                  東京都練馬区練馬1丁目20番8号 日建練馬ビル2F
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <div
                    style="
                      display: inline-block;
                      line-height: 1.2em;
                      padding: 0.1em 0;
                    "
                  >
                    設立
                  </div>
                </th>
                <td>2022年3月18日</td>
              </tr>
              <tr>
                <th scope="row">
                  <div
                    style="
                      display: inline-block;
                      line-height: 1.2em;
                      padding: 0.1em 0;
                    "
                  >
                    業種
                  </div>
                </th>
                <td>ソフトウェア業界、情報処理サービス業界、Web・インターネット業界</td>
              </tr>
              <tr>
                <th scope="row">
                  <div
                    style="
                      display: inline-block;
                      line-height: 1.2em;
                      padding: 0.1em 0;
                    "
                  >
                    法人番号
                  </div>
                </th>
                <td>0116−01−025817</td>
              </tr>
              <tr>
                <th scope="row">
                  <div
                    style="
                      display: inline-block;
                      line-height: 1.2em;
                      padding: 0.1em 0;
                    "
                  >
                    事業内容
                  </div>
                </th>
                <td>ネットワークシステムの設計・構築/ネットワークシステムの監視・保守/アプリケーションの設計/開発</td>
              </tr>
              <tr>
                <th scope="row">
                  <div
                    style="
                      display: inline-block;
                      line-height: 1.2em;
                      padding: 0.1em 0;
                    "
                  >
                    代表者
                  </div>
                </th>
                <td>代表取締役社長 松村 裕樹</td>
              </tr>
            </tbody>
          </table>
          <p>
            <strong>Adbc株式会社</strong
            >（エーディービーシー）は、東京都練馬区に本社を置き、システム開発・インフラ構築・WEB、モバイルサービスを提供する会社である。
          </p>
          <div
            class="contentsPanel"
            v-bind:class="{ minimizedPanel: !panelStatus }"
          >
            <div class="hidePanel" v-show="panelStatus" @click="hidePanel()">
              [非表示]
            </div>
            <div class="showPanel" v-show="!panelStatus" @click="showPanel()">
              [表示]
            </div>
            <div class="contentsHeader">目次</div>
            <ul v-bind:class="{ hidePanel: !panelStatus }">
              <li><span>1</span><a>概要</a></li>
              <li><span>2</span><a>企業理念</a></li>
              <li><span>3</span><a>サービス</a></li>
              <li><span>4</span><a>採用</a></li>
              <li><span>5</span><a>沿革</a></li>
              <li><span>6</span><a>問い合わせ</a></li>
            </ul>
          </div>
          <div class="content_main" id="overview">
            <h2>概要</h2>
            <p>
              Adbc株式会社は、IT分野におけるシステム開発・インフラ構築・WEB、モバイルサービスを提供する。本社は東京都練馬区。2022年3月18日に設立。
            </p>
          </div>
          <div class="content_main" id="philosophy">
            <h2>企業理念</h2>
            <p>
              「豊かな生活を送れること」を目標に「仕事のスキルも重要であるが、それ以上に仕事を俯瞰的に見て最適な行動をできる人材」を育成することに注力している。
              ITスキルの高さ以上に複雑なコミュニケーションを必要とする開発やシステム運用で発生する「コミュニケーションコスト」を低減させ、円滑に業務遂行することが第一だと考えている。
              そのスキルはIT分野に関わらず、どの業種や職種でも必要不可欠となるもので、人生において必要なスキルと言っても過言ではない。
              円滑な業務を行えるようになり、無駄な業務をなくしてプライベート時間を増やす、というようによいサイクルを生み出して欲しいと考えている。
            </p>
          </div>
          <div class="content_main" id="service">
            <h2>サービス</h2>
            <p>以下のサービスを展開している。</p>
            <ul>
              <li>システム開発/支援</li>
              <li>システムコンサルティング</li>
              <li>インフラ構築/設計</li>
              <li>セキュリティ診断</li>
            </ul>
          </div>
          <div class="content_main" id="recruitment">
            <h2>採用</h2>
            <ul>
              <li>募集職種：エンジニア/一般事務/営業</li>
              <li>雇用区分：正社員/契約社員</li>
              <li>勤務地：テレワーク（プロジェクト指定の場所）</li>
              <li>勤務時間：フレックス（8h/Day）</li>
              <li>保険：社会保険</li>
              <li>福利厚生：書籍購入/学費補助</li>
              <li>選考の流れ：①書類選考 ②面接</li>
              <li>給与：30万円〜（エンジニアの場合能力に応じて）</li>
            </ul>
          </div>
          <div class="content_main" id="history">
            <h2>沿革</h2>
            <ul>
              <li>2022年3月18日 設立</li>
            </ul>
          </div>
          <div class="content_main" id="contact">
            <h2>問い合わせ</h2>
            <p>採用やサービスに関する問合せは以下のreCAPTCHAを入力し表示されるメールアドレスにメール送信してください。</p>
            <div id="validate" class="fade_in" v-show="captchaStatus">
              <div class="container">
                <div id="captcha" class="captcha">
                  {{ theCaptcha }}
                </div>
                <div class="restart">
                  <button class="link-style-btn" @click="createCaptcha()">
                    表示を変更
                  </button>
                </div>
                <div class="input">
                  <input
                    type="text"
                    v-model="reCaptcha"
                    maxlength="6"
                    placeholder="表示文字を入力して下さい。"
                  />
                </div>
                <div style="padding-top: 5px">
                  <input
                    class="confirm_btn"
                    type="button"
                    value="お問い合わせ先を確認する"
                    @click="validateCaptcha()"
                  />
                </div>
                <div class="errmsg fade_in" style="color: red">{{errMsg}}</div>
              </div>
            </div>
            <input
              class="btn_mail"
              id="btn_mail"
              type="button"
              value="詳細はこちら"
              @click="showCaptcha()"
              v-show="detailBtnStatus"
            />
          </div>
          <div id="contact_info fade_in" v-show="contactStatus">{{contactInfo}}</div>
        </div>
        <div class="pagefooter">
          最終更新 2022年4月1日 (金) 17:01 （日時は個人設定で未設定ならばUTC）。
          <div class="footerlinks">
            Copyright ©2022-2023 Adbc株式会社 All Rights Reserved
          </div>
        </div>
      </div>
    </div>
  </HpLayout>
</template>

<script>
import '@/assets/hp/css/base.css';

import HpLayout from '@/layouts/HpLayout.vue';

export default {
  name: 'HomeJP',
  components: {
    HpLayout,
  },
  data: function () {
    return {
      detailBtnStatus: true,
      panelStatus: true,
      captchaStatus: false,
      contactStatus: false,
      theCaptcha: this.createCaptcha(),
      reCaptcha: "",
      errMsg: null,
      contactInfo: 'sales@adbcc.jp'
    };
  },
  methods: {
    hidePanel() {
      this.panelStatus = false
    },
    showPanel() {
      this.panelStatus = true
    },
    showCaptcha() {
      this.captchaStatus = true
      this.detailBtnStatus = false
    },
    createCaptcha() {
      let captcha = new Array();
      for (let q = 0; q < 6; q++) {
        if (q % 2 == 0) {
          captcha[q] = String.fromCharCode(Math.floor(Math.random() * 26 + 65));
        } else {
          captcha[q] = Math.floor(Math.random() * 10 + 0);
        }
      }
      return (this.theCaptcha = captcha.join(""));
    },
    validateCaptcha() {
      if (this.reCaptcha == "") {
        this.errMsg = "※表示文字の入力は必須です。";
      } else if (this.reCaptcha != this.theCaptcha) {
        this.errMsg = "※入力した文字に誤りがあります。";
      } else {
        this.errMsg = "";
        this.panelStatus = false
        this.captchaStatus = false
        this.contactStatus = true
        console.log(this.contactStatus)
      }
    },
  },
};
</script>

<style scoped>
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
  display: block;
}
audio,
canvas,
progress,
video {
  display: inline-block;
  vertical-align: baseline;
}
audio:not([controls]) {
  display: none;
  height: 0;
}
[hidden],
template {
  display: none;
}
a {
  background-color: transparent;
}
a:active,
a:hover {
  outline: 0;
}
::placeholder {
  font-size: 13px;
}
abbr[title] {
  border-bottom: 1px dotted;
}
b,
strong {
  font-weight: bold;
}
dfn {
  font-style: italic;
}
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}
mark {
  background: #ff0;
  color: #000;
}
small {
  font-size: 80%;
}
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sup {
  top: -0.5em;
}
sub {
  bottom: -0.25em;
}
img {
  border: 0;
  max-width: 100%;
  display: inline-block;
}
svg:not(:root) {
  overflow: hidden;
}
figure {
  margin: 1em 40px;
}
hr {
  box-sizing: content-box;
  height: 0;
}
pre {
  overflow: auto;
}
code,
kbd,
pre,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}
button,
input,
optgroup,
select,
textarea {
  color: inherit;
  font: inherit;
  margin: 0;
}
button {
  overflow: visible;
}
button,
select {
  text-transform: none;
}
button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}
button[disabled],
html input[disabled] {
  cursor: default;
}
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}
input {
  line-height: normal;
}
input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  height: auto;
}
input[type="search"] {
  -webkit-appearance: textfield;
  box-sizing: content-box;
}
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}
fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}
legend {
  border: 0;
  padding: 0;
}
textarea {
  overflow: auto;
}
optgroup {
  font-weight: bold;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
td,
th {
  padding: 0;
}
html {
  color: #222;
  font-size: 1em;
  line-height: 1.4;
}
caption {
  display: table-caption;
}
tbody {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
}
tr {
  display: table-row;
  vertical-align: inherit;
  border-color: inherit;
}
::-moz-selection {
  background: #b3d4fc;
  text-shadow: none;
}
::selection {
  background: #b3d4fc;
  text-shadow: none;
}
hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
  margin: 1em 0;
  padding: 0;
}
audio,
canvas,
iframe,
img,
svg,
video {
  vertical-align: middle;
}
fieldset {
  border: 0;
  margin: 0;
  padding: 0;
}
textarea {
  resize: vertical;
}
.browserupgrade {
  margin: 0.2em 0;
  background: #ccc;
  color: #000;
  padding: 0.2em 0;
}
.hidden {
  display: none !important;
}
.visuallyhidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.visuallyhidden.focusable:active,
.visuallyhidden.focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto;
}
.invisible {
  visibility: hidden;
}
.clearfix:before,
.clearfix:after {
  content: " ";
  display: table;
}
.clearfix:after {
  clear: both;
}
.content_main li {
  list-style-type: disc;
  margin-left: 24px;
  text-align: left;
}
@media only screen and (min-width: 35em) {
}
@media print,
  (-webkit-min-device-pixel-ratio: 1.25),
  (min-resolution: 1.25dppx),
  (min-resolution: 120dpi) {
}
@media print {
  *,
  *:before,
  *:after,
  *:first-letter,
  *:first-line {
    background: transparent !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
  a,
  a:visited {
    text-decoration: underline;
  }
  a[href]:after {
    content: " (" attr(href) ")";
  }
  abbr[title]:after {
    content: " (" attr(title) ")";
  }
  a[href^="#"]:after,
  a[href^="javascript:"]:after {
    content: "";
  }
  pre,
  blockquote {
    border: 1px solid #999;
    page-break-inside: avoid;
  }
  thead {
    display: table-header-group;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  img {
    max-width: 100% !important;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
}
h1,
h2,
h3,
h4,
h5,
h6 {
  color: #000;
  background: none;
  font-weight: normal;
  margin: 0;
  overflow: hidden;
  padding-top: 0.5em;
  padding-bottom: 0.17em;
}
.article h1 {
  font-family: sans-serif;
  border-bottom: 1px solid #a2a9b1;
}
.article h2 {
  font-size: 1.6em;
  margin: 0.5em 0 0.5em 0;
  font-family: sans-serif;
  border-bottom: 1px solid #a2a9b1;
  line-height: 1.4em;
  padding-bottom: 0em;
}
.article h3 {
  font-weight: bold;
  font-size: 1.2em;
}
.article p.roleNote {
  padding: 1em 0 0 1.6em;
  font-style: italic;
}
p.siteSub {
  font-size: 92%;
}

ul {
  list-style-type: none;
  list-style-image: none;
  margin: 0;
  padding: 0.3em 0 0 0;
}
h1 {
  line-height: 1.3;
  margin-bottom: 0.25em;
  padding: 0;
  letter-spacing: 0;
  font-size: 2.3em;
}
a,
a:visited {
  color: #0645ad;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
.wrapAll {
  width: 100%;
}
.sidebar {
  float: left;
  width: 9em;
  padding: 3px 1.5em 10px 1.3em;
  position: absolute;
}
.sidebar h3 {
  font-size: 0.75em;
  color: #4d4d4d;
  font-weight: normal;
  margin: 0.5em 0 0 0;
  padding: 0.25em 0;
  cursor: default;
  border: 0;
  border-bottom: 1px solid #d8d8d8;
}
.sidebar li {
  line-height: 1.125em;
  margin: 0;
  padding: 0.25em 0;
  font-size: 0.75em;
  word-wrap: break-word;
}
.rightbox {
  border: 1px solid #a2a9b1;
  border-spacing: 3px;
  background-color: #f8f9fa;
  color: black;
  margin: 0.5em 0 0.5em 1em;
  padding: 0.2em;
  float: right;
  clear: right;
  text-align: left;
  font-size: 88%;
  line-height: 1.5em;
  width: 20em;
}
.rightbox th {
  text-align: left;
  vertical-align: top;
  width: 31%;
  padding: 0.25em 0.5em;
}
.rightbox td {
  text-align: left;
  width: 69%;
  padding: 0.25em 0.5em;
}
.rightbox-title {
  font-size: 125%;
  font-weight: bold;
  text-align: center;
}
.rightbox-image {
  text-align: center !important;
}
.logo {
  margin-bottom: 20px;
}
.navigation {
  padding: 0.15em 0 0 0.45em;
}
.mainsection {
  margin: 0 0 0 11em;
}
.headerLinks {
  text-align: right;
  padding: 0.8em 1.4em;
  font-size: 0.72em;
  color: #777;
  letter-spacing: 0.017em;
}
.headerLinks a {
  display: inline-block;
  margin: 0 0 0 0.5em;
}
.article {
  padding: 1.25em 1.5em 1.5em 1.5em;
  border-left: 1px solid #a7d7f9;
  background: #fff;
  line-height: 1.6;
  font-size: 0.875em;
  border-top: 1px solid #a7d7f9;
  border-bottom: 1px solid #a7d7f9;
}
.article p {
  line-height: inherit;
  margin: 0.5em 0;
}
span.user {
  background-position: left top;
  background-repeat: no-repeat;
  background-image: url(../../assets/hp/img/user-ico.png);
  padding-left: 15px !important;
}
.contentsPanel {
  border: 1px solid #a2a9b1;
  background-color: #f8f9fa;
  padding: 5px;
  font-size: 95%;
  position: relative;
  line-height: 1.7em;
  width: 140px;
}
.contentsHeader {
  font-family: sans-serif;
  font-weight: bold;
  text-align: left;
}
.hidePanel,
.showPanel {
  float: right;
  margin: 0 5px;
  position: absolute;
  right: 5px;
  cursor: pointer;
  color: #0645ad;
  top: 4px;
}
.contentsPanel ul li span {
  display: inline-block;
  margin-right: 8px;
}
.contentsPanel ul li {
}
.contentsPanel ul {
  padding: 0 0 5px 5px;
}
.contentsPanel ul li ul {
}
.contentsPanel ul li ul li {
  padding: 0 0 0 25px;
}
.minimizedPanel .showPanel {
  display: block;
}
.minimizedPanel .hidePanel {
  display: none;
}
.contentsPanel.minimizedPanel {
  width: 130px;
}
.minimizedPanel .contentsHeader {
  text-align: left;
}
.lavenderBox {
  background: #fdfdfd;
  border: 1px solid #a2a9b1;
  clear: both;
  font-size: 88%;
  text-align: center;
  padding: 3px;
  line-height: 1.7em;
  margin: 1em auto 0;
}
.lavenderBox .header {
  background: #ccccff;
  padding: 0.25em 1em;
  line-height: 1.5em;
  text-align: center;
  font-weight: bold;
  color: #0645ad;
  font-size: 115%;
  margin-bottom: 3px;
}
.lavenderBox .subtitle {
  background: #ddddff;
}
.linklist a:after {
  content: " · ";
  font-weight: bold;
}
.linklist a:last-child:after {
  content: "";
}
.linklist a {
  white-space: nowrap;
}
.categories {
  border: 1px solid #a2a9b1;
  background-color: #f8f9fa;
  padding: 5px;
  margin-top: 1em;
  font-size: 1.1em;
  clear: both;
}
.categories a:after {
  content: " | ";
  font-weight: bold;
}
.categories a:last-child:after {
  content: "";
}
.pagefooter {
  padding: 1.5em 1.3em 2em;
  font-size: 75%;
  line-height: 2em;
}
.pagefooter a {
  display: inline-block;
  margin-right: 1em;
}
@media screen and (max-width: 850px) {
  #searchInput {
    width: 110px;
  }
  #simpleSearch {
    width: 138px;
  }
}
@media screen and (max-width: 700px) {
  .tabsRight {
    display: none;
  }
}
@media screen and (max-width: 550px) {
  .sidebar {
    width: 6em;
    padding: 3px 0.5em 10px 0.5em;
  }
  .mainsection {
    margin: 0 0 0 7em;
  }
  .contentsPanel {
    width: auto;
  }
}
@media screen and (max-width: 400px) {
  #simpleSearch {
    display: none;
  }
}
@media screen and (max-width: 390px) {
  .rightbox {
  border: 1px solid #a2a9b1;
  border-spacing: 3px;
  background-color: #f8f9fa;
  color: black;
  padding: 0.2em;
  float: right;
  clear: right;
  text-align: left;
  font-size: 88%;
  line-height: 1.5em;
  width: 19em;
}
}

.btn_mail {
  width: 180px;
  border: 1px solid #a09d9d;
  background-color: #f8f9fa;
  color: #0645ad;
  transition: 0.8s;
  display: inline-block;
  outline: none;
  box-sizing: border-box;
  font-size: inherit;
  font-weight: 500;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  height: 32px;
  line-height: 32px;
  padding: 0px 12px;
  vertical-align: middle;
  font-size: 14px;
}
.btn_mail:hover {
  background: #091e4214;
  text-decoration: inherit;
  transition-duration: 0s, 0.15s;
  color: #0645ad;
}

.confirm_btn {
  width: 200px;
  border: 1px solid #a09d9d;
  background-color: #f8f9fa;
  color: #0645ad;
  transition: 0.8s;
  display: inline-block;
  outline: none;
  box-sizing: border-box;
  font-size: inherit;
  font-weight: 500;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
  height: 32px;
  line-height: 32px;
  padding: 0px 12px;
  vertical-align: middle;
  font-size: 14px;
}
.confirm_btn:hover {
  background: #091e4214;
  text-decoration: inherit;
  transition-duration: 0s, 0.15s;
  color: #0645ad;
}
.fade_in {
  animation-name: fadeInAnime;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  opacity: 0;
}
@keyframes fadeInAnime {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
.container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: start;
}

.box {
  background-color: #f1f2f2;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  border-radius: 5px;
  padding: 20px;
}

.captcha {
  font-family: "Comic Sans MS", sans-serif;
  font-style: italic;
  font-weight: bold;
  font-size: 2em;
  padding: 3px;
  border-radius: 5px;
  text-decoration: line-through;
  color: #a0a0a0;
  background-color: #0c0c0c;
}

.restart a {
  text-decoration: none;
}

.errmsg {
  color: black;
  padding: 5px;
  transition: 0.5s ease;
}

input {
  width: 100%;
  margin-bottom: 3px;
}

button.link-style-btn {
  cursor: pointer;
  border: none;
  background: none;
  color: #0033cc;
}
button.link-style-btn:hover {
  text-decoration: underline;
}
</style>
